import {Route} from 'react-router-dom';
import CustomRouteWrap from './_routeWrap';

// 使用 webpack 的 require.context 方法，导入检索需要配置的文件
// true：是否检索子文件夹
// /\.index\.(tsx)$/：文件名匹配正则
// @ts-ignore
const routers = require.context('./', true, /index\.tsx$/);

export function pathHandle(key: string) {
    const path = key
        .replace(/^\./, '')
        .replace(/\.(tsx)$/, '')
        .replace(/\/index(\[\w+])*$/, '$1')
        .replace(/\[(\w+)]/g, '/:$1')
        .replace(/\/\//g, '/');
    return path;
}

function makeRouterMap() {
    const routerMap = {} as any;
    const keys = routers.keys();
    for (const key of keys) {
        let path = pathHandle(key);

        let Route = null;
        // 处理路由组件
        if (path) {
            Route = routers(key).default;
        }
        // 清除路由内配置
        path = path.replace(/(\((\w+)\))/g, '').replace(/{\w+}/g, '');

        routerMap[path] = {
            path,
            children: [],
            isTop: true,
            key,
            Route: Route,
        };
    }
    return routerMap;
}

export function childrenRouteHandler(items: any) {

    return items.map((route: any) => {
        const Routes: JSX.Element[] = [];
        const path = route.path.toLowerCase();
        const Component = routers(route.key).default;
        route?.children?.forEach((routeChild: any) => {
            const routeChildPath = routeChild.path.toLowerCase();
            const RouteChildComponent = routers(routeChild.key).default;
            Routes.push(
                <Route
                    key={routeChildPath}
                    path={routeChildPath}
                    element={(
                        <CustomRouteWrap
                            path={routeChildPath}
                        >
                            <RouteChildComponent />
                        </CustomRouteWrap>
                    )}
                />
            );
        });

        Routes.push(
            <Route
                key={path}
                path={path}
                element={(
                    <CustomRouteWrap
                        path={path}
                    >
                        <Component />
                    </CustomRouteWrap>
                )}
            />
        );
        return Routes;
    });
}

export function routerHandle() {
    const routerMap = makeRouterMap();
    const routerMapKeys = Object.keys(routerMap);

    routerMapKeys.forEach(key => {
        const parentPath = key.replace(/\/:\w+$/, '').replace(/\/\w+$/, '');
        const parent = routerMap[parentPath];
        if (parent) {
            routerMap[key].isTop = false;
            parent.children.push(routerMap[key]);
        }
    });

    const topRouters = [] as any[];
    routerMapKeys.forEach(key => {
        const route = routerMap[key];
        if (route.isTop) {
            topRouters.push(route);
        }
    });

    return childrenRouteHandler(topRouters);
}
